import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { WorkflowService } from 'src/app/service/workflow/workflow.service';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'workflow-toolbar',
  templateUrl: './workflow-toolbar.component.html',
  styleUrls: ['./workflow-toolbar.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class WorkflowToolbarComponent extends BaseComponent implements OnInit {

  groups: string[] = ["General", "Actions", "Custom"];
  activeGroup: string = "General";
  searchText: string = "";
  workflowTitle: string = "";

  constructor(private workflowService: WorkflowService, dataService:DataService) {
    super(dataService);
  }

  ngOnInit() {       
    // listener for change of workflow title
    this.workflowService.currentWorkflowName.subscribe(name => {
      this.workflowTitle = name;
    });    
  }

  changeCurrentGroup(groupName: string){
    this.activeGroup = groupName;
  }


  updateWorkflowTitle(newValue: string){
    this.workflowService.changeWorkflowName(newValue);
  }

}
